/*$( window ).on( 'load resize', function () {
	// Single Product image height: https://github.com/woocommerce/woocommerce/blob/master/assets/js/frontend/single-product.js#L165
	var $image = $( '.woocommerce-product-gallery__wrapper' );

	if ( $image ) {
		setTimeout( function () {
			var setHeight = $( '.product-hero .hero-summary' ).innerHeight();
			//console.log(setHeight);

			$image.height( setHeight ).css( 'opacity', '1' );
		}, 100 );
	}
} );*/


/**
 * WooCommerce: AJAX "Add to Cart" on Single products
 * https://aceplugins.com/ajax-add-to-cart-button-on-the-product-page-woocommerce/
 */
$( 'body.single-product form.cart' ).on( 'submit', function (e) {
	e.preventDefault();

	var form = $( this ),
		product_id = form.find('[name=product_id]').val() || form.find( '[type="submit"]' ).val(),
		variation_id = form.find( '[name="variation_id"]' ).val() || 0,
		quantity = form.find( '[name="quantity"]' ).val() || 1;

	$( '.cart-contents' ).addClass( 'updated' );

	// Trigger "add-to-cart" URL
	$.post( globalData.add_to_cart_url + 'add-to-cart=' + ( 0 !== variation_id ? variation_id : product_id ) + '&quantity=' + quantity, function () {
		// Refresh cart count
		$( document.body ).trigger( 'wc_fragment_refresh' );
		$( '.cart-contents' ).removeClass( 'updated' )
	} );
} );
